module.exports = __webpack_public_path__ + "img/d7f9d030ccf121eb45efc25c9dd73cdf.svg";